import fetchApi from 'services/api/connector';

/**
 * Fetches the What's New changelog.
 * @returns {Promise<{ changelogUrl: string, versions: Array<object> }>} Changelog payload.
 */
// eslint-disable-next-line import/prefer-default-export
export const fetchWhatsNew = () => fetchApi('whats_new');
